import React, { Component } from 'react'
import Slider from 'components/form/stepSlider/index'
import FormTitle from 'components/fulcrum/formTitleWithRisk/index'

class TwoDecimalSlider extends Component {
  render() {
    const { title, isRisk, ...sliderProps } = this.props
    return (
    <FormTitle
      title={title}
      isRisk={isRisk}
    >
      <Slider step={0.01} {...sliderProps} editable />
    </FormTitle>
    )
  }
}

export default TwoDecimalSlider
